import { ORDER_SERVICE_NAME, ORDER_COMPLETE_SERVICE_NAME } from "../../../../services/order"

import { CompleteOrderController } from "./complete-order.controller"

//#region Asset Imports

import * as TEMPLATE from './complete-order.tpl.html'
import './complete-order.scss'

//#endregion

export const COMPONENT_NAME: string = 'ordersCompleteOrder'

export class CompleteOrderComponent {

    controller = [
        ORDER_SERVICE_NAME,
        ORDER_COMPLETE_SERVICE_NAME,
        CompleteOrderController
    ]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE
}